import { useEffect, useState } from "react";
import { getOSInfo, getParsedOSInfo, type OSInfo } from "@akina/infra";

export const useGetOSInfo = () => {
  const [osInfo, setOsInfo] = useState<OSInfo | null>(null);
  const [parsedOsInfo, setParsedOsInfo] = useState<string>("");

  useEffect(() => {
    const osInfo = getOSInfo();
    const parsedOSInfo = getParsedOSInfo(osInfo);
    setOsInfo(osInfo);
    setParsedOsInfo(parsedOSInfo);
  }, []);

  return { osInfo, parsedOsInfo };
};
